module.exports = __webpack_public_path__ + "176e0dd6d1b30a8f013fe937d7eb354c.svg";